import {getNearestHour} from '@/common/helpers/date/getNearestHour';

/** Detect a nearest hour to the now  */
export function useCurrentHour(hours: {hour: number}[], timezoneOffset: number, allowed?: boolean) {
	// TODO add live update
	if (allowed === false) {
		return undefined;
	}

	return getNearestHour(
		hours.map(item => item.hour),
		timezoneOffset,
	);
}

useCurrentHour.displayName = 'useCurrentHour';
